module.exports = __webpack_public_path__ + "img/trap-green.847178fa.png";